module.exports = __webpack_public_path__ + "img/پیچیده.735cd15f.png";